/**
 * 履歴の食品の表示部品（パレットの行・チップと、履歴タブの一覧で共通）
 */

import type { MealItemHistoryEntry } from '@/api/types/nutrition'
import { cn } from '@/lib/utils'

import { formatMonthDay, scaleQuantity } from './utils'

/** 食品名と量（倍率を掛けた表記） */
export function HistoryEntryName({ entry, className }: { entry: MealItemHistoryEntry; className?: string }) {
  const quantity = scaleQuantity(entry.quantity, entry.scale)
  return (
    <span className={cn('truncate', className)}>
      {entry.name}
      {quantity && <span className="ml-1 text-[10px] font-normal text-muted-foreground">({quantity})</span>}
    </span>
  )
}

/** 最後に食べた日と回数（例: 10/27・8回） */
export function HistoryEntryLastEaten({ entry, className }: { entry: MealItemHistoryEntry; className?: string }) {
  return (
    <span className={cn('shrink-0 tabular-nums text-muted-foreground', className)}>
      {formatMonthDay(entry.last_eaten_on)}
      {entry.eaten_count > 1 && `・${entry.eaten_count}回`}
    </span>
  )
}
